import { lazy } from 'react'
import { IModuleDefinition } from '../types'

const ListsContainer = lazy(() => import('./ListsContainer'))

const moduleDefinition: IModuleDefinition = {
  routeProps: {
    path: '/lists/*',
    private: true,
    component: ListsContainer
  },
  name: 'Lists'
}

export default moduleDefinition
